import React from 'react';
import { Box, ListItem, Stack } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';

const suggestedSearches = [
  'Status',
  'Stage',
  'Owner Id',
  'Created Date',
  'Last Modified Date',
  'Opportunity',
  'Lead',
  'Case',
  'Account',
  'Contact',
];

export const MetadataElementsSearchEmpty = ({
  onClick,
}: {
  onClick: (searchText: string) => Promise<void>;
}) => {
  return (
    <Box padding={2}>
      <Stack direction="column" gap={2.5}>
        <Typography variant="caption" color={colors.grey[700]}>
          Suggested searches
        </Typography>
        <Stack ml={-2} mr={-2}>
          {suggestedSearches.map((suggestedSearch) => (
            <ListItem
              key={suggestedSearch}
              onClick={() => onClick(suggestedSearch)}
              sx={{
                cursor: 'pointer',
                marginBottom: 0,
                '&:hover': {
                  backgroundColor: colors.grey[100],
                },
              }}
            >
              <Typography variant="body" color={colors.grey[900]}>
                {suggestedSearch}
              </Typography>
            </ListItem>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
